import {
  create,
  destroy,
  getAll,
  IPatchSliceBody,
  IPostSliceBody,
  update
} from 'redux/api/Slices'

import * as sliceActions from './actions'

import { Dispatch } from 'redux'

import { useThunkActions } from 'redux/actions/useThunkActions'

import * as UserEvents from 'redux/api/internal/UserEvents'
import { Action } from 'types/GlobalUserEvents'

import { toggleSnackbarOpen } from 'redux/actions/Snackbar'
import { SnackbarMessage } from 'types/GlobalSnackbar'

export function tryGetAllSlices() {
  return (dispatch: Dispatch) => {
    dispatch(sliceActions.getAll())

    getAll()
      .then((response) => {
        dispatch(sliceActions.getAllSuccess(response.data.data))
      })
      .catch(() => {
        dispatch(sliceActions.getAllFailed())
      })
  }
}

function tryCreateSlice(body: IPostSliceBody) {
  return (dispatch: Dispatch) => {
    dispatch(sliceActions.create())

    create(body)
      .then((response) => {
        UserEvents.log({
          action: Action.SLICE_CREATED,
          context: null,
          dashboard_id: null,
          dashboard_group_id: null
        })

        dispatch(sliceActions.createSuccess(response.data.data))

        dispatch(toggleSnackbarOpen(SnackbarMessage.SliceCreated))
      })
      .catch(() => {
        dispatch(sliceActions.createFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.SliceCreatedFailed))
      })
  }
}

function tryDeleteSlice(id: string) {
  return (dispatch: Dispatch) => {
    dispatch(sliceActions.destroy())

    destroy(id)
      .then(() => {
        UserEvents.log({
          action: Action.SLICE_DELETED,
          context: null,
          dashboard_id: null,
          dashboard_group_id: null
        })

        dispatch(sliceActions.destroySuccess({ id }))

        dispatch(toggleSnackbarOpen(SnackbarMessage.SliceDeleted))
      })
      .catch(() => {
        dispatch(sliceActions.destroyFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.SliceDeletedFailed))
      })
  }
}

function tryUpdateSlice(id: string, body: IPatchSliceBody) {
  return (dispatch: Dispatch) => {
    dispatch(sliceActions.update())

    update(id, body)
      .then((response) => {
        UserEvents.log({
          action: Action.SLICE_EDITED,
          context: null,
          dashboard_id: null,
          dashboard_group_id: null
        })

        dispatch(sliceActions.updateSuccess(response.data.data))

        dispatch(toggleSnackbarOpen(SnackbarMessage.SliceUpdated))
      })
      .catch(() => {
        dispatch(sliceActions.updateFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.SliceUpdatedFailed))
      })
  }
}

export const useSliceActions = () => {
  return {
    tryCreateSlice: useThunkActions(tryCreateSlice),
    tryDeleteSlice: useThunkActions(tryDeleteSlice),
    tryUpdateSlice: useThunkActions(tryUpdateSlice)
  }
}
